import { z } from '@harvestiq/zod';
import { UserRoles } from './user-roles';

export const removeUserRoleRequestParamsSchema = z.object({
  userId: z.string().uuid(),
  roleId: z.nativeEnum(UserRoles),
});
